import React, { forwardRef, useState, useImperativeHandle } from "react";
import { Button, Text, TwDropdown as Dropdown, Icon} from "@ui-component-library";

const RegionStep = forwardRef(({ onNext, formData }, ref) => {
    const [selectedRegion, setSelectedRegion] = useState(formData?.region)

     useImperativeHandle(ref, () => ({
            validateAndReturn() {
                if (selectedRegion == null) {
                    return { errors: true};
                }
    
                return {
                    data: {
                        region:selectedRegion,
                        step:"treeform_region_selection"
                    }
                };
            }
        }));
    
    return (
        <div className="h-full flex flex-col justify-center items-center">
            <div className="w-full md:w-[500px] px-10 grid grid-row gap-4">
                <Text variant="text-xl/leading-normal/normal" className="text-white">2. Var äger du skog? (välj län, max 1 län)</Text>
                <div className="flex items-center justify-center">
                    <Dropdown
                        description=""
                        name="region"
                        value={selectedRegion}
                        onChange={(val) => { setSelectedRegion(val); }}
                        options={Window.react_data.regions}
                        placeholder="Var äger du skog"
                    />             
                </div>
            </div>
            <div className="fixed bottom-0 left-0 w-full sm:static sm:w-auto sm:h-auto sm:flex sm:justify-center sm:items-center mt-4">
                <div className="flex justify-center items-center py-4 px-2 sm:py-0">
                    <Button
                        onClick={()=>onNext({data:{
                            region:selectedRegion,
                            step:"treeform_region_selection"
                        }})}
                        variant="quaternary"
                        fullWidth
                        disabled={selectedRegion ? false:true}
                    >
                    Nästa
                    <Icon
                        className="fill-charcoal-500"
                        name="ArrowRightSimple"
                        size="large"
                    />
                    </Button>
                </div>
            </div>
        </div>
    )
});

export default RegionStep;